import React, { Component } from 'react';

class Footer extends Component {
	render() {
		return (
			<footer
				id='contacts'
				className='section is-primary is-small has-text-centered'
			>
				<div className='container is-narrow'>
					<h2 className='title is-size-4-touch' id='contact'>
						Contact me via{' '}
						<a className='email' href='mailto:slavanik.dev@gmail.com'>
							email
						</a>
						<div className='footer-title-wrap'></div> or social media
					</h2>
					<div className='social-icons '>
						<p className='field'>
							<a
								className='button is-medium'
								href='https://www.linkedin.com/in/slava-nik'
								target='_blank'
								rel='noopener noreferrer'
								aria-label='Linkedin profile'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									viewBox='0 0 30 30'
									width='30px'
									height='30px'
								>
									<path d='M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z' />
								</svg>
							</a>
							<a
								className='button is-medium'
								href='https://github.com/Slava-Nik'
								target='_blank'
								rel='noopener noreferrer'
								aria-label='Github profile'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='24'
									height='24'
									viewBox='0 0 24 24'
								>
									<path d='M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z' />
								</svg>
							</a>
							<a
								className='button is-medium'
								href='https://t.me/slava_nik96'
								target='_blank'
								rel='noopener noreferrer'
								aria-label='Telegram profile'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									viewBox='0 0 64 64'
									width='24'
									height='24'
									style={{ transform: 'scale(2.5)' }}
								>
									<path d='M39.589,40.968 c0.404-1.241,2.301-13.615,2.534-16.054c0.071-0.738-0.163-1.229-0.619-1.449c-0.553-0.265-1.371-0.133-2.322,0.21 c-1.303,0.47-17.958,7.541-18.92,7.951c-0.912,0.388-1.775,0.81-1.775,1.423c0,0.431,0.256,0.673,0.96,0.924 c0.732,0.261,2.577,0.82,3.668,1.121c1.05,0.29,2.243,0.038,2.913-0.378c0.709-0.441,8.901-5.921,9.488-6.402 c0.587-0.48,1.056,0.135,0.576,0.616c-0.48,0.48-6.102,5.937-6.844,6.693c-0.901,0.917-0.262,1.868,0.343,2.249 c0.689,0.435,5.649,3.761,6.396,4.295c0.747,0.534,1.504,0.776,2.198,0.776C38.879,42.942,39.244,42.028,39.589,40.968z' />
								</svg>
							</a>
						</p>
					</div>
					<div className='copyright'>
						© Last updated: December 2022 by Slava Nikolaevich
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
